'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import * as React from 'react'

// lib
import { BackIcon } from '../icons'
import BackButton, { BackButtonProps } from '../back-button/back-button'

/* -----------------------------------------------------------------------------
 * HeaderBackButton
 * -------------------------------------------------------------------------- */

export type HeaderBackButtonProps = BackButtonProps & {}

const HeaderBackButton = (props: HeaderBackButtonProps) => {
  return (
    <BackButton {...props}>
      <BackIcon width={24} height={24} fill='violet' />
    </BackButton>
  )
}

export default HeaderBackButton
